import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";

export interface ResourceLink {
  title: string;
  href: string;
  description: string;
}

interface HelpfulResourcesProps {
  resources: ResourceLink[];
  title?: string;
}

export const HelpfulResources = ({ resources, title = "Hilfreiche Ressourcen" }: HelpfulResourcesProps) => {
  return (
    <section className="my-12">
      <div className="flex items-center gap-2 mb-6">
        <BookOpen className="h-6 w-6 text-primary" />
        <h2 className="text-2xl font-bold text-foreground">{title}</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {resources.map((resource, index) => (
          <Link
            key={index}
            to={resource.href}
            className="group block bg-card border border-border rounded-lg p-5 hover:border-primary/50 hover:shadow-md transition-all duration-200"
          >
            <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors mb-2 text-sm">
              {resource.title}
            </h3>
            <p className="text-xs text-muted-foreground leading-relaxed mb-3">
              {resource.description}
            </p>
            <span className="inline-flex items-center gap-1 text-xs font-medium text-primary">
              Weiterlesen <ArrowRight className="h-3 w-3 group-hover:translate-x-0.5 transition-transform" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
};
